import React from 'react';

import { RenderComponent } from '@bcp-channels-sharedcomponents-reactjs/core';

import { TooltipAb } from './tooltip.ab';
import { TooltipBcp } from './tooltip.bcp';

export interface TooltipInnerProps {
	title?: string;
	content?: string;
	onOpenFallback?: () => void;
}

export const Tooltip: React.FC<TooltipInnerProps> = (props: TooltipInnerProps): JSX.Element => {
	return (
		<RenderComponent
			components={{
				ab: { desktop: <TooltipAb {...props} />, mobile: <TooltipAb {...props} />, intranet: null },
				bcp: { desktop: <TooltipBcp {...props} />, mobile: <TooltipBcp {...props} />, intranet: null },
			}}
		/>
	);
};

export default Tooltip;
